import { render } from "./ReceiverCheckout.vue?vue&type=template&id=a6c15e9c"
import script from "./ReceiverCheckout.vue?vue&type=script&lang=js"
export * from "./ReceiverCheckout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__